export default __webpack_public_path__ + "static/media/医生勋章.f6ce107c.png";